import { render } from "./DistrictWiseInstitutionCount.vue?vue&type=template&id=1f18d2e8"
import script from "./DistrictWiseInstitutionCount.vue?vue&type=script&lang=js"
export * from "./DistrictWiseInstitutionCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/v3-stage.teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__